exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".chapter-tip[data-v-2be234ad]{margin:0 .666667rem}.chapter-tip-title[data-v-2be234ad]{color:#fff;height:.933333rem;border-bottom:.013333rem solid #575776;line-height:.933333rem}.chapter-tip-con[data-v-2be234ad]{margin-top:.333333rem;line-height:.48rem}.chapter-tip-btn[data-v-2be234ad]{margin-top:.826667rem;padding:.16rem .04rem}", ""]);

// exports
